/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Account_Manual_Removal_BrowserInputs */

const en_delete_account_manual_removal_browser = /** @type {(inputs: Delete_Account_Manual_Removal_BrowserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your account has been deleted. To remove remaining data from this device, clear this site's stored data in your browser settings.`)
};

const es_delete_account_manual_removal_browser = /** @type {(inputs: Delete_Account_Manual_Removal_BrowserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu cuenta ha sido eliminada. Para eliminar los datos restantes de este dispositivo, borra los datos almacenados de este sitio en la configuración de tu navegador.`)
};

const ar_delete_account_manual_removal_browser = /** @type {(inputs: Delete_Account_Manual_Removal_BrowserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم حذف حسابك. لإزالة البيانات المتبقية من هذا الجهاز، امسح البيانات المخزنة لهذا الموقع من إعدادات المتصفح.`)
};

/**
* | output |
* | --- |
* | "Your account has been deleted. To remove remaining data from this device, clear this site's stored data in your browser settings." |
*
* @param {Delete_Account_Manual_Removal_BrowserInputs} inputs
* @param {{ locale?: "en" | "es" | "ar" }} options
* @returns {LocalizedString}
*/
export const delete_account_manual_removal_browser = /** @type {((inputs?: Delete_Account_Manual_Removal_BrowserInputs, options?: { locale?: "en" | "es" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Account_Manual_Removal_BrowserInputs, { locale?: "en" | "es" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delete_account_manual_removal_browser(inputs)
	if (locale === "es") return es_delete_account_manual_removal_browser(inputs)
	return ar_delete_account_manual_removal_browser(inputs)
});